import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { withRouter, Link } from 'react-router-dom';

import { toggleLeftAside } from 'actions/ui';

import Navigation from './components/navigation';
import { SystemText } from 'e4shared';
import BlobImage from 'components/blobImage';

export const Header = ({ history }) => {
    const dispatch = useDispatch();
    const { user } = useSelector(state => state.user);
    const { leftAsideOpen } = useSelector(state => state.ui);

    const toggleSideNav = () => {
        dispatch(toggleLeftAside());
    };

    if (!user) return null;

    user.companySettings = user.companySettings || {};

    const logo = 'richardson-logo-icon.svg';
    const logoFull = 'richardson-logo-full.svg';

    const customerLogo =
        user.companySettings.logo?.indexOf('http') >= 0 ? (
            <img
                className={user.companySettings.onWhite ? 'customer-image-inverse' : ''}
                alt=""
                loading="lazy"
                src={user.companySettings.logo}
            />
        ) : (
            <BlobImage
                className={user.companySettings.onWhite ? 'customer-image-inverse' : ''}
                folder="logo"
                src={user.companySettings.logo}
            />
        );

    return (
        <header className="main-header">
            <Link tabIndex="1" to="/" className="logo" aria-label="Home Page">
                <span className="logo-mini">
                    <img src={`/dist/img/${logo}`} alt="" loading="lazy" />
                </span>
                <span className="logo-lg pt3 pull-left">
                    <img src={`/dist/img/${logoFull}`} style={{ width: '150px', height: '24px' }} alt="" loading="lazy" />
                </span>
            </Link>
            {user.companySettings.logo && (
                <span className="navbar-customer-image inline pull-right hidden visible-xs">{customerLogo}</span>
            )}
            <nav className={`navbar navbar-static-top ${leftAsideOpen ? 'open' : ''}`}>
                <button
                    tabIndex="2"
                    onClick={() => toggleSideNav()}
                    data-testid="button-nav-toggle"
                    className="pointer sidebar-toggle"
                    data-toggle="offcanvas"
                >
                    <span className="sr-only">{SystemText('Header/Toggle')}</span>
                </button>
                {user.companySettings.logo && <div className="navbar-customer-image inline hidden-xs">{customerLogo}</div>}
                <Navigation />
            </nav>
        </header>
    );
};

export default withRouter(Header);
